import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var partial_arg = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x >= -344447064) {
    return Atdgen_codec_runtime.Encode.constr0("Download");
  } else {
    return Atdgen_codec_runtime.Encode.constr0("Upload");
  }
});

function write__1(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(partial_arg, param);
}

var read__1 = Atdgen_codec_runtime.Decode.option_as_constr(Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Upload",
/* `Single */
[-306849112,
/* Upload */
-1058128351]],
/* :: */
[
/* tuple */
["Download",
/* `Single */
[-306849112,
/* Download */
-344447064]],
/* [] */
0]]));
var write_info = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_blob, "id", t.id),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__1, "instructions", t.instructions),
  /* [] */
  0]]);
});
var read_info = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_blob, param);
    }, json),
    instructions: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("instructions", read__1, param);
    }, json)
  };
});
var read_id = Id_bs$SolvuuApi0.read_blob;
var write_id = Id_bs$SolvuuApi0.write_blob;
export { read_id, write_id, read_info, write_info };
/* partial_arg Not a pure module */